import { AccordionDetails, List, styled } from "@mui/material";

export const Styled = {
    AccordionDetails: styled(AccordionDetails)`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
    OrderedList: styled(List)`
        list-style: decimal;
    `,
    UnorderedList: styled(List)`
        list-style: disc;
        margin-left: 2px;
    `,
};
